<template>
    <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner
      :background="info1.image ? info1.image.url : item.image.url"
      :title="!pgLoading ? $t('app.about') : ''"
      :subtitle="!pgLoading ? $t('app.about') : ''"
    >
    </Banner>

    <!--about-us-area start-->
    <section class="about-area pt-50 pb-70">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="about-img mb-60 pos-rel">
              <div
                class="about-img__thumb pr-45 wow fadeInUp2 animated"
                data-wow-delay=".1s"
                style="
                  visibility: visible;
                  animation-delay: 0.1s;
                  animation-name: fadeInUp2;
                "
              >
                <img
                  :src="
                    info1.image
                      ? info1.image.url
                      : '/assets/img/logo/min-logo.png'
                  "
                  loading="lazy"
                  alt=""
                />
              </div>

              <div
                class="experience-box heding-bg wow fadeInUp2 animated"
                data-wow-delay=".3s"
                style="
                  visibility: visible;
                  animation-delay: 0.3s;
                  animation-name: fadeInUp2;
                "
              >
                <h2 class="d-flex" style="align-items: center;">
                  <span class="mx-1">{{ expYear }}</span>
                  <span>{{ $t("app.expYears") }}</span>
                </h2>
                <h4 class="semi-02-title">{{ $t("app.charity_work") }}</h4>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="about-wrap-04 mb-60 pl-40">
              <div
                class="section-title text-left mb-20 wow fadeInUp2 animated"
                data-wow-delay=".1s"
              >
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]"
                    ><i class="fas fa-home"></i
                  ></span>
                  {{ info1.title }}
                </h6>
                <h2>{{ $t("app.about_msg") }}</h2>
                <p v-html="info1.body"></p>
              </div>

              <ul class="nav nav-tabs mb-35 mt-5" id="myTab" role="tablist">
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="home-tab"
                    data-toggle="tab"
                    href="#home"
                    role="tab"
                    aria-controls="home"
                    aria-selected="true"
                    >{{ $t("app.mission") }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="profile-tab"
                    data-toggle="tab"
                    href="#profile"
                    role="tab"
                    aria-controls="profile"
                    aria-selected="false"
                    >{{ $t("app.vision") }}</a
                  >
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="contact-tab"
                    data-toggle="tab"
                    href="#contact"
                    role="tab"
                    aria-controls="contact"
                    aria-selected="false"
                    >{{ $t("app.target") }}</a
                  >
                </li>
              </ul>

              <div class="tab-content" id="myTabContent">
                <div
                  class="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div class="inner-content d-sm-flex align-items-center mr-35">
                    <div v-if="pgLoading" class="inner-content__img mr-20">
                      <img src="/assets/img/about/05.jpg" alt="" loading="lazy"/>
                    </div>
                    <div v-if="!pgLoading" class="inner-content__img mr-20">
                      <img
                        v-if="info3.image"
                        loading="lazy"
                        :src="info3.image.url"
                        alt="image"
                        width="200px"
                      />
                    </div>
                    <div class="inner-content__text">
                      <!-- <h3>{{ $t("app.about1") }}</h3> -->
                      <p v-html="info3.body1"></p>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div class="inner-content d-sm-flex align-items-center">
                    <div v-if="pgLoading" class="inner-content__img mr-20">
                      <img src="/assets/img/about/05.jpg" alt="" />
                    </div>
                    <div v-if="!pgLoading" class="inner-content__img mr-20">
                      <img
                      loading="lazy"
                        v-if="info3.image"
                        :src="info3.image.url"
                        alt="image"
                        width="200px"
                      />
                    </div>
                    <div class="inner-content__text">
                      <!-- <h3>{{ $t("app.about2") }}</h3> -->
                      <p v-html="info3.body2"></p>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="contact"
                  role="tabpanel"
                  aria-labelledby="contact-tab"
                >
                  <div class="inner-content d-sm-flex align-items-center">
                    <div v-if="pgLoading" class="inner-content__img mr-20">
                      <img src="/assets/img/about/05.jpg" alt="about charity" />
                    </div>
                    <div v-if="!pgLoading" class="inner-content__img mr-20">
                      <img
                      loading="lazy"
                        v-if="info3.image"
                        :src="info3.image.url"
                        alt="image"
                        width="200px"
                      />
                    </div>
                    <div class="inner-content__text">
                      <!-- <h3>{{ $t("app.about3") }}</h3> -->
                      <p v-html="info3.body3"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <thumbnails></thumbnails>

    <!--counter-area start-->
    <TotalCount></TotalCount>

    <section class="what-we-area grey-bg2 pos-rel pt-125 pb-95">
      <div
        class="right-help"
        :style="
          'background-image: url(' +
          (info4.image ? info4.image.url : '/assets/img/logo/min-logo.png') +
          ')'
        "
      ></div>
      <div class="container">
        <div class="row align-items-center">
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="about-wrapper we-wrapper mb-30">
              <div
                class="section-title text-left mb-20 wow fadeInUp2 animated"
                data-wow-delay=".1s"
                :style="
                  $i18n.locale == 'en' ? 'text-align:left !important' : ''
                "
              >
                <h6>
                  <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                    <i class="fas fa-home"></i>
                  </span>
                  {{ $t("home.achievement") }}
                </h6>
                <h3>{{ info4.title }}</h3>
              </div>
              <p
                class="wow fadeInUp2 animated"
                data-wow-delay=".2s"
                v-html="info4.body"
              ></p>
              <br />
              <a
                data-toggle="modal"
                data-target="#donation-modal"
                class="theme_btn theme_btn_bg wow fadeInUp2 animated"
                data-wow-delay=".5s"
                href="javascript:;"
              >
                {{ $t("app.donate_Now") }}
                <span :style="[locale == 'en' ? { left: 'auto' } : {}]">
                  <i class="fas fa-angel-right"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--blog-area start-->
    <LatestNews></LatestNews>
  </div>
</template>

<script>
// import iziToast from 'izitoast';

export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    Thumbnails: () => import("@/components/Thumbnails.vue"),
    TotalCount: () => import("@/components/TotalCount.vue"),
    LatestNews: () => import("@/components/LatestNews.vue"),
  },
  data() {
    return {
      //

      item: {
        image: {
          url: "/assets/img/about/about-banner.png",
        },
      },
      expYear: "",

      refs: "about",
      btnLoading: false,

      //
      locale: "ar",
      pgLoading: true,
      info1: "",
      rows: [],
      news: [],

      magnific_popup: false,
      video_url: "",

      info2: "",
      info3: "",
      info4: "",

      tab: 1,
    };
  },
  mounted() {

    const startYear = 2022;
    const date = new Date();
    const currentYear = date.getFullYear();
    this.expYear = currentYear - startYear;
  },
  created() {
    //

    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      window.scrollTo(0, 0);
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/about",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 20,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;

          // info
          this.info1 = res.data.info1;
          this.info2 = res.data.info2;
          this.info3 = res.data.info3;
          this.info4 = res.data.info4;
          this.fetchNews();
          // console.log(res.data.rows);
          // console.log(res.data.info1);
          // console.log(res.data.info2);
          // console.log(res.data.info3);
        })
        .catch(() => {})
        .finally(() => {});
    },

    fetchNews() {
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/news",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          status: "active",
          paginate: 3,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.news = res.data.rows;
          //  console.log(this.news);
        })
        .catch(() => {})
        .finally(() => {});
    },

    changeTab: function (id) {
      this.tab = id;
    },

    openVideo: function (path) {
      this.magnific_popup = true;
      this.video_url = path;
    },

    closeMagnific: function () {
      this.magnific_popup = false;
      this.video_url = "";
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-size {
  cursor: pointer;
  height: 50px;
}
</style>
